Vendd.Scripts.load(function () {

    initFaq();

    function initFaq() {
        var $wrapper = $('.x-faq-list');

        if ($wrapper.length < 1) {
            return;
        }

        var $question = $('.question', $wrapper);

        $question.click(function (e) {

            if (!$(this).siblings('.answer').hasClass('active')) {

                $('.active', $wrapper).stop(true, true).slideUp(10).removeClass('active').siblings().removeClass('open-faq icon-up').addClass('icon-down');

                $(this).siblings('.answer').addClass('active').stop(true, true).slideDown(10);

                $(this).addClass('open-faq icon-up').removeClass('icon-down').stop(true, true).slideDown(10);

            } else {

                $('.active', $wrapper).stop(true, true).slideUp(10).removeClass('active');

                $(this).removeClass('open-faq icon-up').addClass('icon-down').stop(true, true).slideDown(10);

            }

        });
    }
});